import React from 'react';
import { Link } from 'react-router-dom';
import { ListingDoc } from '@bb/domain/dist/schemas';
import type { JsonObject } from '@/app-package';
import { NoListingsSVG } from '@bb/elements-web';

import { ListingListItem, Icon } from 'components';
import { featureEnabled } from 'utils';
import { EmptyContainer, EmptySection } from '../components';

type ListingsSectionProps = {
  listings: JsonObject<ListingDoc>[];
  isTeamListing?: boolean;
};

const ListingsSection: React.FC<ListingsSectionProps> = ({
  listings,
  isTeamListing,
}) => {
  if (listings.length === 0) {
    if (featureEnabled('showingsMadeEasyFeature') && !isTeamListing) {
      return (
        <EmptySection
          dataCy="no-listings"
          Image={<NoListingsSVG width={142} height={120} />}
          mainText="No listings yet"
          secondaryText="View your listings here."
        />
      );
    }
    // Team dashboard will continue to use old empty design for now
    return (
      <EmptyContainer data-cy="no-listings">
        <Icon type="antdHomeFilled" width={34} color="gray6" offset={[0, 2]} />
        <span>No listings yet</span>
      </EmptyContainer>
    );
  }

  return (
    <>
      {' '}
      {listings.map(listing => (
        <Link
          key={listing._id}
          to={`/listing/${listing._id}/view`}
          data-cy={`view-${listing._id}`}
        >
          <ListingListItem
            listing={listing}
            type={isTeamListing ? 'team' : 'full'}
            inDashboard
          />
        </Link>
      ))}
    </>
  );
};

export default ListingsSection;
